import React from 'react'
import styled from 'styled-components'
import AnalyticsDisplay from '../user-dashboard-analytics/app'
import withLocationState from 'shared/components/with-location-state'
import SideNav from 'shared/components/form/settings/side-nav'
import { fontCss } from '../user/components/container'
import DashboardBanner from './dashboard-banner'
import DashboardUserContext from './context'

const AccountManagementColumn = styled(SideNav)`
    ${fontCss};
    margin-right: 20px;
`
const DashboardColumn = styled.div`
    width: 770px;
`

const Container = styled.div`
    width: 1040px;
    display: flex;
    flex-wrap: wrap;
`

const DashboardPage = ({ dashboardUser }) => {
    return (
        <DashboardUserContext.Provider value={{ user: dashboardUser }}>
            <div>
                <DashboardBanner />
                <Container>
                    <AccountManagementColumn user={dashboardUser} />
                    <DashboardColumn>
                        <AnalyticsDisplay />
                    </DashboardColumn>
                </Container>
            </div>
        </DashboardUserContext.Provider>
    )
}

export default withLocationState(['dashboard_user'])(DashboardPage)
